<template lang="pug">
v-breadcrumbs.pt-0(:items='breadcrumbs' v-if='breadcrumbs')
  v-icon(slot='divider' color='grey') chevron_right
  template(slot='item' slot-scope='props')
    v-menu(v-model='props.item.isMenuShow' :disabled='props.item.disabled')
      a(slot='activator' :class="[props.item.disabled && 'v-breadcrumbs__item--disabled']")
        v-icon(v-if='props.item.icon' small) {{ props.item.icon }}
        span(v-else) {{ props.item.text }}
      v-card
        v-list
          v-list-tile(v-for='(i, index) in props.item.menu' :to='i.to || false' :key='index')
            v-list-tile-title {{ i.text }}
</template>

<script>
export default {
  name: 'FormBreadcrumb',
  computed: {
    period () {
      return parseInt(this.$route.params.period)
    },
    level () {
      return parseInt(this.$route.params.level)
    },
    breadcrumbs () {
      const $t = this.$t.bind(this)
      const $tc = this.$tc.bind(this)

      const period = this.period
      const level = this.level
      const formItems = this.formItems || []

      if (period === undefined || level === undefined) return null

      const periodMenu = formItems.map(v => {
        const level = v.levels.some(l => this.level === l.level) ? this.level : 1
        return {
          text: $tc('period', +v.period, { n: +v.period }), // 選單項目文字
          to: { name: 'form', params: { period: v.period, level } },
        }
      })
      const currLevel = formItems.find(v => +this.period === +v.period) || { levels: [] }
      const levelMenu = currLevel.levels.map(v => {
        return {
          text: $t(this.convertLevelText(v.level)),
          to: { name: 'form', params: { period: this.period, level: v.level } },
        }
      })

      return [
        {
          text: $t('報名表單'),
          icon: 'fab fa-wpforms',
          disabled: true,
        },
        {
          text: $tc('period', +period, { n: +period }),
          menu: periodMenu,
        },
        {
          text: $t(this.levelTable[level]) || '...',
          menu: levelMenu,
        },
      ]
    },
    formInfo () {
      return this.$store.state.formInfo
    },
    formItems () {
      const formInfo = this.formInfo || {}
      const list = Object.keys(formInfo).sort((a, b) => a - b).map(_ => {
        return {
          period: _,
          levels: Object.keys(formInfo[_]).sort((a, b) => a - b).map($ => {
            return { level: $, groups: formInfo[_][$].groups }
          }),
        }
      })
      return list
    },
  },
}
</script>

<style scoped lang="sass">

</style>
